// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Pagination_componentWrapper__dY8qr"};